<template>
  <div>
    <div class="item" @click="gotoBargain">
      <div class="image-wrap">
        <img :src="item.activity_pic" />
        <div class="tag" v-if="setting.inventory && item.can_purchase > 0">剩余 {{ item.can_purchase }}</div>
        <div class="tag end" v-if="setting.inventory && item.can_purchase <= 0">已售罄</div>
      </div>
      <div class="info">
        <div class="name">{{ item.activity_name }}</div>
        <div class="goods-floor-price">
          <span>{{currencySymbol}}</span>
          <span class="integer-price">{{ item.unit_price }}</span>
        </div>
        <div class="btn-bargain" :style="{ background: colorFirst }" v-if="item.can_purchase > 0">
          去砍价
        </div>
        <div class="btn-bargain end" v-if="item.can_purchase <= 0">
          已售罄
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NotBargainItem",
  props: {
    item: Object,
    setting: Object,
    colorFirst: String,
    currencySymbol: String
  },
  data() {
    return {};
  },
  components: {},
  methods: {
    gotoBargain() {
      this.$emit("gotoBargain");
    }
  }
};
</script>

<style scoped lang="scss">
.item {
  padding: 0.3rem 0.2rem;
  height: 2.2rem;
  background: #ffffff;
  display: flex;
}
.item:last-child {
  border-bottom: none;
}
.image-wrap {
  position: relative;
  flex: 0 0 2.2rem;
  width: 2.2rem;
  margin-right: 0.42rem;
}
.image-wrap > img {
  display: block;
  width: 2.2rem;
  height: 2.2rem;
  border-radius: 0.12rem;
}
.image-wrap .tag {
  position: absolute;
  top: 0.15rem;
  left: -0.2rem;
  z-index: 99;
  padding: 0 0.11rem;
  height: 0.3rem;
  font-size: 0.22rem;
  line-height: 0.3rem;
  border-radius: 0 0.2rem 0.2rem 0;
  color: #ffffff;
  background: linear-gradient(
    90deg,
    rgba(255, 77, 29, 1),
    rgba(251, 123, 0, 1)
  );
  &.end {
    background: #eee;
    color: #888;
  }
}
.info {
  position: relative;
  flex: 1;
}
.name {
  position: absolute;
  left: 0;
  top: .11rem;
  /* width: 100%; */
  font-size: 0.3rem;
  font-weight: 400;
   display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  -webkit-box-orient: vertical;
}
.goods-floor-price {
  position: absolute;
  left: 0;
  top: 1.7rem;
  color: #e51722;
  font-size: 0;
  line-height: 0.46rem;
  font-weight: 500;
  > span {
    font-size: 0.32rem;
  }
}

.integer-price {
  font-size: 0.46rem !important;
}
.btn-bargain {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 1.4rem;
  height: 0.6rem;
  text-align: center;
  font-size: 0.28rem;
  color: #ffffff;
  background: rgba(255, 46, 31, 1);
  border-radius: 0.05rem;
  display: flex;
  align-items: center;
  justify-content: center;
  &.end {
    background: #eee;
    color: #888;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Bargain/components/NotBargainingItem.vue